export const RU_OKSM_CODE = '643';
export const BY_OKSM_CODE = '112';
export const KG_OKSM_CODE = '417';
export const KZ_OKSM_CODE = '398';
/** В справочнике `51` и `051` — разные записи; после normalize оба → `051`. */
export const AM_OKSM_CODE = '051';

/** Числовые коды ОКСМ приводим к 3 цифрам (`36` → `036`). Slug (`oksm_5`) оставляем как есть. */
export const normalizeRegistrationOksmCode = (oksmCode: string | null | undefined): string => {
	if (oksmCode == null || oksmCode === '') {
		return '';
	}

	const trimmed = String(oksmCode).trim();

	if (/[a-zA-Z_]/.test(trimmed)) {
		return trimmed;
	}

	const digits = trimmed.replace(/\D/g, '');

	if (!digits) {
		return trimmed;
	}

	return digits.padStart(3, '0');
};

export const isBelarusRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	return normalizeRegistrationOksmCode(oksmCode) === BY_OKSM_CODE;
};

export const isKyrgyzstanRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	return normalizeRegistrationOksmCode(oksmCode) === KG_OKSM_CODE;
};

export const isKazakhstanRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	return normalizeRegistrationOksmCode(oksmCode) === KZ_OKSM_CODE;
};

export const isArmeniaRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	const code = normalizeRegistrationOksmCode(oksmCode);

	return code === AM_OKSM_CODE || code === '51';
};

export const isRussiaRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	return normalizeRegistrationOksmCode(oksmCode) === RU_OKSM_CODE;
};

/**
 * Гражданство/резидентство с тем же сценарием регистрации, что РФ
 * (паспортные поля, фото, статусы). Пока сюда же относится Беларусь.
 * Шаг «Введите ИНН» только при резидентстве РФ.
 */
export const isDomesticRegistrationOksm = (oksmCode: string | null | undefined): boolean => {
	const code = normalizeRegistrationOksmCode(oksmCode);

	return code === RU_OKSM_CODE || code === BY_OKSM_CODE;
};

/**
 * «Давайте познакомимся»: имена на русском + адрес регистрации в РФ —
 * для всех гражданств, кроме РФ.
 */
export const isNonRussiaPersonalInfoForm = (oksmCode: string | null | undefined): boolean => {
	const code = normalizeRegistrationOksmCode(oksmCode);

	return Boolean(code) && !isRussiaRegistrationOksm(code);
};
